import tinycolor from "tinycolor2";

export const isDarkColor = (color: string): boolean => {
  return tinycolor(color).isDark();
};
